import styled, { css } from 'styled-components';
import device from 'utils/device'

export default styled.div`
  ${({ displayState }) => css`
    background-color: white;
    width: 100vw;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    
    @media ${device.laptop} {
      box-shadow: 0px 4px 40px rgba(160, 174, 192, 0.15);
      max-height: calc(100vh - 70px);
      max-width: calc(100vw - 100px);
      border-radius: 20px;
      width: 800px;
      height: unset;
    }

    @media screen and (min-width: 1280px) {
      border-radius: ${displayState?.visibleSidebar ? '20px 0px 0px 20px' : '20px'};
      transition: border-radius 500ms;
      transform:  ${displayState?.visibleSidebar ? ' translate(-200px)' : ''};
      transition: transform 500ms;
    }
  `}
`;